import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './order-alerts-components.module.less';
import { FormattedNumber } from 'react-intl';

const Badge = ({ value = 0, className = '' }) => (
  <div className={classnames(style.badge, className)}>
    <FormattedNumber value={value} />
  </div>
);

Badge.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};

export default Badge;
